import { Component } from "@angular/core";

@Component({
  selector: "app-abm-teams-content",
  templateUrl: "abm-teams-content.component.html",
})
export class AbmTeamsContentComponent {}
